import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
  Scrolls the page to the top on every route change.
  If the URL has a hash (e.g. /about#partners), scrolls to that element
  instead. Used by App.js.
*/
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer to next frame so the target section is mounted.
      const id = hash.replace('#', '');
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
